var map = {
	"./back.svg": "c557",
	"./example.svg": "30c3",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./home.svg": "6bbe",
	"./login-mall.svg": "0de5",
	"./marker.svg": "edcd",
	"./order-return-reason.svg": "7355",
	"./order-return.svg": "480b",
	"./order-setting.svg": "e4b6",
	"./order.svg": "11ff",
	"./password.svg": "2a3d",
	"./product-add.svg": "cbc9",
	"./product-attr.svg": "9741",
	"./product-brand.svg": "60fc",
	"./product-cate.svg": "57a7",
	"./product-comment.svg": "60f4",
	"./product-list.svg": "e2f5",
	"./product-recycle.svg": "5be0",
	"./product.svg": "8d30",
	"./sms-ad.svg": "847c",
	"./sms-coupon.svg": "befc",
	"./sms-flash.svg": "e267",
	"./sms-hot.svg": "b888",
	"./sms-new.svg": "d072",
	"./sms-subject.svg": "1724",
	"./sms.svg": "694b",
	"./table.svg": "47f1",
	"./total-today.svg": "fda3",
	"./total-week.svg": "aff9",
	"./total-yesterday.svg": "8f00",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";